import React from "react";
import styles from "./Breadcrumb.module.scss";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
export default function BreadCrumb({ menu }) {
  const navigate = useNavigate();
  return (
    <div className={styles.BreadCrumb}>
      <div className="container">
        {menu.map((item: any, i: number) => {
          return (
            <div
              className={classNames(
                styles.item,
                menu.length === i + 1 ? styles.active : ""
              )}
              onClick={() => menu.length !== i + 1 && navigate(item.link)}
            >
              {item.title}
            </div>
          );
        })}
      </div>
    </div>
  );
}
